import "./minuteByMinuteTimeline.sass";
import { useEffect, useState } from "react";
import {
  getCommentary,
  transformCommentaryData,
} from "../../../../services/minute-a-minute/getCommentary";
import { useAutoRefresh } from "../../hooks/useAutoRefresh";
import { getEventCatalogInfo } from '../../../../config/eventCatalog.js'
import Loading from "../../../loading/loading.js";

export default function MinuteByMinuteTimeline({ matchId = null, refresh = false, country = null }) {
  const [timelineEvents, setTimelineEvents] = useState([]);
  const [loading, setLoading] = useState(!!matchId);
  const [error, setError] = useState(null);

  // Función para obtener datos con o sin loading
  const fetchCommentaryData = async (showLoading = true) => {
    if (!matchId) {
      setError("No se proporcionó el ID del partido");
      setLoading(false);
      return;
    }

    try {
      if (showLoading) setLoading(true);

      const rawData = await getCommentary(matchId, country);
      const transformed = transformCommentaryData(rawData);

      // Enriquecer eventos con información de catálogo
      const timelineData = transformed.map((event) => {
        const catalogInfo = getEventCatalogInfo(event.eventType);
        const isInCatalog = catalogInfo !== null;

        return {
          ...event,
          label: catalogInfo?.name || "",
          classIcon: catalogInfo?.class_icon || "",
          showLabel: isInCatalog && (catalogInfo?.showLabel !== false),
        };
      });

      setTimelineEvents(timelineData);
      setError(null);
    } catch (err) {
      console.error("Error cargando comentarios:", err);
      setError(err.message || "Error cargando comentarios");
    } finally {
      if (showLoading) setLoading(false);
    }
  };

  // Usar hook de auto-refresh si refresh es true
  useAutoRefresh(refresh, fetchCommentaryData, [matchId, refresh, country]);

  // Cargar datos iniciales si refresh es false
  useEffect(() => {
    if (!refresh) {
      fetchCommentaryData(true);
    }
  }, [matchId, refresh, country]);

  if (loading) {
    return (
      <div className="minute-by-minute-timeline-container">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="minute-by-minute-timeline-container">
        <div className="error-message">Error: {error}</div>
      </div>
    );
  }

  if (timelineEvents.length === 0) {
    return (
      <div className="minute-by-minute-timeline-container">
        <div className="empty-message">No hay eventos disponibles</div>
      </div>
    );
  }

  return (
    <div className="minute-by-minute-timeline-container">
      <div className="timeline-content">
        {/* Línea central vertical */}
        <div className="timeline-axis" />

        {/* Eventos - Mantienen el orden de recepción */}
        {timelineEvents.map((event) => (
          <div
            key={event.id || `${event.minute}-${event.eventType}`}
            className={`timeline-event ${event.classIcon}`}
          >
            {/* Columna izquierda - Minuto e ícono */}
            <div className="timeline-left">
              <div className="event-minute-badge">
                {String(event.time).trim().length > 0 && String(event.time).trim() !== "'" &&
                  <p className="minute-value">
                    <span className="icon-amx-minuto"></span>
                    {event.time}</p>
                }
              </div>
            </div>

            {/* Columna derecha - Contenido */}
            <div className="timeline-right">
              {/* Mostrar label solo si el evento está en catálogo y showLabel es true */}
              {event.showLabel && (
                <p className={`event-label`}>
                  <span className={`timeline-icons ${event.classIcon}`}></span>
                  {event.label}
                </p>
              )}
              {/* Mostrar descripción siempre */}
              <p className="event-description">{event.comment}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
